import cmp from './IncompleteAccount'

export default cmp
